import React from "react";
import PropTypes from "prop-types";
import { errorBoundaryFallback } from "../../../locales/en";
import "./modal.scss";

function ModalFallback({ fixHeight = "400px" }) {
  const handleReload = (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    window.location.reload();
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center mt-50"
      style={{ height: fixHeight }}
    >
      <div className="text-center">
        <h4>{errorBoundaryFallback.common.listFallback.text1}</h4>

        <button className="refreshBtnColor" onClick={handleReload}>
          <strong>
            {errorBoundaryFallback.common.listFallback.reloadLink}
          </strong>
        </button>
        <span>{` ${errorBoundaryFallback.common.listFallback.text2} `}</span>
      </div>
    </div>
  );
}

ModalFallback.propTypes = {
  fixHeight: PropTypes.string
};

export default ModalFallback;
